import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../services/notifications.service'
import { NotificationStatus } from 'src/app/shared/enums/notification-tabs.enum'
import { Notification, notificationsFilter } from '../../models/notification'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-notifications-dropdown',
	templateUrl: './notifications-dropdown.component.html',
	styleUrls: ['./notifications-dropdown.component.scss'],
})
export class NotificationsDropdownComponent implements OnInit, OnDestroy {
	notifications: Notification[] = []
	hasNew = false
	totalCount = 0
	NotificationFilter: notificationsFilter = {
		Paging: { PageNumber: 1, PageSize: 7 },
		IsRead: '',
		NotificationTap: 0,
	}
	subscriptions = new Subscription()
	notificationEnum = NotificationStatus
	constructor(
		private notificationsService: NotificationService,
		public translate: TranslateService,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.getNotifications()
		this.subscriptions.add(
			this.notificationsService.messageReceivingSubject.subscribe({
				next: (message: any) => {
					this.NotificationFilter?.NotificationTap == 0 ||
					this.NotificationFilter?.NotificationTap ==
						message?.data?.notificationType
						? this.notifications.unshift(message?.data)
						: null
					this.hasNew = true
					this.cd.detectChanges()
				},
			})
		)
	}

	getNotifications(isScroll: boolean = false) {
		this.subscriptions.add(
			this.notificationsService
				.getNotificationList(this.NotificationFilter)
				.subscribe((res: any) => {
					isScroll
						? this.notifications.push(...res.result?.items)
						: (this.notifications = res.result?.items)
					this.totalCount = res?.result?.totalCount
				})
		)
	}

	onScrollDown(event: any) {
		if (this.totalCount > this.notifications?.length) {
			this.NotificationFilter.Paging.PageNumber++
			this.getNotifications(true)
		}
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe()
	}
}
